/**
 * Helpers for the Site Closure Log (see `SiteClosureReport` in Operations.jsx).
 */

/**
 * Group the site queries by patient so the closure log can show each patient's
 * queries in that patient's own section.
 *
 * Returns an object keyed by patient id; each value is the list of that patient's
 * queries, in the order they were received (the backend orders them by patient,
 * then by creation date).
 */
export const groupQueriesByPatient = (queries = []) => {
  const grouped = {};
  for (const q of queries) {
    const patientId = q.patient.id;
    if (!(patientId in grouped)) {
      grouped[patientId] = [];
    }
    grouped[patientId].push(q);
  }
  return grouped;
};
